module.exports = {"210681001":"大东街道","210681002":"新兴街道","210681003":"新城街道","210681101":"孤山镇","210681104":"前阳镇","210681105":"长安镇","210681106":"十字街镇","210681107":"长山镇","210681108":"北井子镇","210681109":"椅圈镇","210681110":"黄土坎镇","210681113":"马家店镇","210681114":"龙王庙镇","210681115":"小甸子镇","210681117":"菩萨庙镇","210681118":"黑沟镇","210681119":"新农镇","210681206":"合隆满族乡","210681401":"示范农场","210681402":"黄土坎农场","210681403":"海洋红农场","210681404":"兴隆农场","210681405":"五四农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210681.json
// module id = 637
// module chunks = 0